export const SET_TICKER_INFO = "set_ticker_info";
export const UPDATE_STOCK_INPUT = "update_stock_input";
export const AUTH_USER = "auth_user";
export const UNAUTH_USER = "unauth_user";
export const AUTH_ERROR = "auth_error";
export const SET_INTERVAL_ID = "set_interval_id";
export const UPDATE_SUMMARY_INPUT = "update_summary_input";
export const TOGGLE_HIDE_UNHIDE = "toggle_hide_unhide";
export const UPDATE_FONT_SIZE = "increase_font_size";
export const SET_CURRENT_USER = "set_current_user";
export const LAST_UPDATE_TIME = "last_update_time";
export const UPDATE_PRICES = "update_prices";
export const SET_CHART_INFO = "set_chart_info";
export const FILL_SIGNIN_EMAIL = "fill_signin_email";
export const ADD_USER_ERROR = "add_user_error";
export const SET_TICKER_SEARCH_INFO = "set_ticker_search_info";
export const SET_TRADE_HISTORY_INFO = "get_trade_history_info";
export const REMOVE_TRADE_HISTORY_ITEM = "remove_trade_history_item";
export const CHANGE_CURRENT_QUARTER = "change_current_quarter";
export const SET_TICKER_NEWS_INFO = "SET_TICKER_NEWS_INFO";
export const TOGGLE_TICKER_STRIKETHROUGH = "TOGGLE_TICKER_STRIKETHROUGH";
export const UPDATE_TRADE_HISTORY_INPUT = "update_trade_history_input";
export const UPDATE_SPX_QUARTERLY = "update_spx_quarterly";

export const SOCKET_UPDATE = "SOCKET_UPDATE";
export const SOCKET_CONNECT = "socket_connect";
export const SOCKET_DISCONNECT = "socket_disconnect";
export const SOCKET_SUBSCRIBE = "socket_subscribe";
export const SOCKET_UNSUBSCRIBE = "socket_unsubscribe";

export const NOTI_TIMEOUT = 4500;

export const BASE_URL = () => {
  const env = process.env.REACT_APP_ENV;
  // return "https://scmportfolio.com"
  if (env === "dev") {
    return "http://localhost:8080";
  } else if (env === "prod") {
    return "https://scmportfolio.com";
  } else {
    return "http://localhost:8080";
  }
};
